var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.columns),function(bucket,colIndex){return _c('b-col',{key:colIndex,attrs:{"cols":"12","md":_vm.bootstrapColSpan}},[_vm._l((bucket),function(item){return _vm._t("default",null,{"item":item})})],2)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }